import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

const STORAGE_KEY = 'lang';
const SUPPORTED_LANGS = ['en', 'de'] as const;
type Lang = (typeof SUPPORTED_LANGS)[number];

function resolveInitialLang(): Lang {
  const stored = localStorage.getItem(STORAGE_KEY);
  return SUPPORTED_LANGS.includes(stored as Lang) ? (stored as Lang) : 'en';
}

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private translate = inject(TranslateService);

  readonly currentLang = toSignal(this.translate.onLangChange.pipe(map((e) => e.lang as Lang)), {
    initialValue: resolveInitialLang(),
  });

  constructor() {
    this.translate.use(resolveInitialLang());
  }

  toggle() {
    const next: Lang = this.currentLang() === 'en' ? 'de' : 'en';
    this.set(next);
  }

  set(lang: string) {
    this.translate.use(lang);
    localStorage.setItem(STORAGE_KEY, lang);
  }
}
